import { defineComponent } from 'vue';
import Icon from '@common/layout/Icon.vue';
import translator from '~/zf/frontend/common/mixins/translator';
export default defineComponent({
    name: 'TreeNode',
    components: { Icon },
    compatConfig: {
        MODE: 3,
    },
    mixins: [translator],
    props: {
        node: {
            type: Object,
            required: true,
        },
        level: {
            type: Number,
            default: 0,
        },
        shouldCascade: {
            type: Boolean,
            required: true,
        },
    },
    computed: {
        paddingLeft() {
            return this.level === 0 ? '0px' : '30px';
        },
    },
});
